export const environment = {
  production: true,
  apiKey: "nkdsQkLR5GkxZaggpNlKIUtzhAfYmAsc"
};
